import React from "react";

interface HelpProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconHelp: React.FC<HelpProps> = ({ className, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24" fill="none" transform="scale(-1 1)">
    <path d="M3 5v15.793a.5.5 0 0 0 .854.353l3.853-3.853A1 1 0 0 1 8.414 17H19a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 12c-.8.622-1.85 1-3 1s-2.2-.378-3-1m0-3.98V8m6 .02V8" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>


);
export default IconHelp;
